import { Component, OnInit, EventEmitter, AfterViewInit } from "@angular/core";
import * as html2pdf from 'html2pdf.js';
import { ClientesService } from "../../services/clientes.service";
import { VendasService } from "../../services/vendas.service";


@Component({
  selector: 'app-espelho-pdf',
  templateUrl: './espelho-pdf.component.html',
  styleUrls: ['./espelho-pdf.component.css']
})
export class EspelhoPdfComponent implements OnInit {

  priceList: any;

  emitter: EventEmitter<void> = new EventEmitter();

  lsClients: any;
  lsPedidoVenda: any;

  parameters = {
    IdVendedor: "",
    cnpj: "",
    razaoSocial: "",
    idpedido: ""
  };

  paramsPedido = {
    idpedido: "",
    dtEmissaoPedido: ""
  };

  constructor(
    private clientService: ClientesService,
  ) {}

  ngOnInit() {
    this.search();
  }

  ngAfterViewInit(): void {
    this.emitter.emit();
  }

  
  search() {

    const parameters = {
      ...this.parameters
    }

    this.clientService.getEspelhoPedido(parameters).subscribe(
      data => {

        this.lsClients = data;

        this.paramsPedido.idpedido = this.lsClients[0].pedido;
        this.paramsPedido.dtEmissaoPedido = this.lsClients[0].dtEmissaoPedido;

        this.searchPedido();

        console.log(this.lsClients);
      },
      error => console.log(error)
    );
  }

  searchPedido() {

    this.clientService.getReportPedidoConformeVenda(this.paramsPedido).subscribe(
      data => {
        this.lsPedidoVenda = data;

        console.log(this.lsPedidoVenda, 'priceList')
      },
      error => console.log(error)
    );
  }

  downloadPDF() {
    const config = {
      html2canvas: {
        scale: 1,
        scrollX: 0,
        scrollY: 0,
      },
    };

    const content: Element = document.getElementById('espelho');

    console.log(content, 'content html');

    html2pdf()
      .from(content)
      .set(config)
      .save();
  }

}
